import { Tooltip, Modal, Button, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { GroupMembershipRestrictions } from "@authzsvc/common-react-components";
import PropTypes from "prop-types";
import TooltipIcon from "../common/TooltipIcon";

const GroupMembershipModal = ({ groupId, disabled, onCancel }) => {
  const [visible, setVisible] = useState(false);

  const handleCancel = () => {
    onCancel();
    setVisible(false);
  };

  return (
    <>
      {!disabled && !visible && (
        <Tooltip title="Edit membership restrictions">
          <Button
            id="membershiptRestrictionsButton"
            onClick={() => setVisible(true)}
            icon={<EditOutlined />}
            color="green"
            variant="solid"
            size="small"
          />
        </Tooltip>
      )}
      <Modal
        style={{ minWidth: "90%" }}
        centered
        open={visible}
        onOk={handleCancel}
        onCancel={handleCancel}
        title={
          <>
            <Typography.Title level={5} style={{ margin: 0 }}>
              Membership restrictions
              <TooltipIcon
                size={16}
                title="If specified, it will not be possible to add group members that are not in the restriction groups. No restrictions are applied if the list is empty."
              />
            </Typography.Title>
          </>
        }
      >
        {visible && <GroupMembershipRestrictions groupId={groupId} />}
      </Modal>
    </>
  );
};

GroupMembershipModal.propTypes = {
  groupId: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default GroupMembershipModal;
